import { render, staticRenderFns } from "./PlantDataForm.vue?vue&type=template&id=17939604&"
import script from "./PlantDataForm.vue?vue&type=script&lang=ts&"
export * from "./PlantDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports